let thinkingEnabled = localStorage.getItem('thinkingEnabled') || 0;
let isExpandThink = localStorage.getItem('isExpandThink') || 0;
export default {
  namespaced: true,
  state: () => ({
    isExpandThink: isExpandThink == 1,
    thinkingEnabled: thinkingEnabled == 1,
  }),
  mutations: {
    mIsExpandThink(state, isExpandThink) {
      state.isExpandThink = isExpandThink;
      localStorage.setItem("isExpandThink", isExpandThink ? '1' : '0')
    },
    mThinkingEnabled(state, thinkingEnabled) {
      state.thinkingEnabled = thinkingEnabled;
      localStorage.setItem('thinkingEnabled', thinkingEnabled ? '1' : '0');
    },
  },
}